/**
 * CiaoTypingIndicator — Minimal animated dots
 */

import React from 'react';

const dot = (delay: number): React.CSSProperties => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  background: '#FC7556',
  opacity: 0.5,
  animation: 'ciao-bounce 1.2s ease-in-out infinite',
  animationDelay: `${delay}ms`,
});

const CiaoTypingIndicator: React.FC = () => (
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 10 }}>
    <div
      style={{
        padding: '12px 16px',
        borderRadius: '16px 16px 16px 4px',
        background: 'var(--card-color, #f8f8f8)',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <style>{`
        @keyframes ciao-bounce {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.35; }
          30% { transform: translateY(-4px); opacity: 0.8; }
        }
      `}</style>
      <div style={dot(0)} />
      <div style={dot(150)} />
      <div style={dot(300)} />
    </div>
  </div>
);

export default CiaoTypingIndicator;
